
/**
 * Unified Configuration System
 * Central source of truth for environment variables and build information.
 */

// Build Information (Injected by Vite)
// We use fallbacks to ensure they never show as "undefined"
export const BUILD_DATE = (import.meta.env.VITE_BUILD_DATE as string) || (window as any).__BUILD_DATE__ || 'BUILD_MISSING';
export const BUILD_ID = (import.meta.env.VITE_BUILD_ID as string) || (window as any).__BUILD_ID__ || 'ID_MISSING';

/**
 * Diagnostic utility to verify config state
 */
export function getConfigDiagnostic() {
  return {
    buildId: BUILD_ID,
    buildDate: BUILD_DATE,
    userAgent: navigator.userAgent,
    isPWA: window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone,
    origin: window.location.origin
  };
}
